// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ComparisonTable.module.css */

.ComparisonTable_container__hzUmK {
  width: 100%;
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 1rem;
}

.ComparisonTable_comparisonTitle__Q7GEe {
  text-align: center;
  font-size: 2.5rem;
  color: #1f2937;
  margin-bottom: 1rem;
  font-weight: 700;
}

.ComparisonTable_comparisonSubtitle__0hxjM {
  text-align: center;
  color: #6b7280;
  font-size: 1.1rem;
  margin-bottom: 3rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.ComparisonTable_table__E3CIp {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.ComparisonTable_table__E3CIp th,
.ComparisonTable_table__E3CIp td {
  padding: 1.2rem 1rem;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
}

.ComparisonTable_table__E3CIp th {
  background: #f8fafc;
  font-weight: 600;
  color: #374151;
  font-size: 1.1rem;
  position: relative;
}

.ComparisonTable_featuresHeader__wOoqm {
  background: #f8fafc !important;
  text-align: left !important;
  font-weight: 700 !important;
  color: #1f2937 !important;
  width: 30%;
}

.ComparisonTable_planHeader__jll7H {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.ComparisonTable_popular__\\+HNBa {
  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);
  position: relative;
}

.ComparisonTable_popular__\\+HNBa::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--primary-gradient);
}

.ComparisonTable_popularTag__huHTL {
  background:var(--primary-gradient);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
}

.ComparisonTable_sectionHeader__KXEH7 {
  background: #f1f5f9;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ComparisonTable_sectionHeader__KXEH7:hover {
  background: #e2e8f0;
}

.ComparisonTable_sectionHeaderContent__eVo6K {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  font-size: 1.1rem;
  color: #374151;
  padding-left: 0px;
}

.ComparisonTable_sectionHeaderContent__eVo6K strong {
  background-color: var(--primary-color);
    color: white;
    padding: 8px 12px;
    border-radius: 12px;
    max-width: 75%;
    word-wrap: break-word;
}

.ComparisonTable_icon__Kwe-2 {
  display: flex;
  align-items: center;
  color: #6b7280;
}

.ComparisonTable_featureRow__m0U9d:hover {
  background: #f8fafc;
}

.ComparisonTable_label__ceOCN {
  text-align: left;
  font-weight: 500;
  color: #374151;
  background: #f8fafc;
}

.ComparisonTable_labelWithIcon__Rfde3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.ComparisonTable_infoIcon__HmFg7 {
  cursor: pointer;
  color: #6b7280;
  font-size: 0.9rem;
  padding: 0.2rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  outline: none;
  border: none;
}

.ComparisonTable_infoIcon__HmFg7:hover {
  background: #e5e7eb;
  color: #374151;
}

.ComparisonTable_featureValue__40PAp {
  font-weight: 500;
  color: #374151;
  line-height: 1.4;
}
.ComparisonTable_featureValue__40PAp .ComparisonTable_true__TaElW {
  color:  green;
  font-size: 1.5rem;
}
.ComparisonTable_featureValue__40PAp .ComparisonTable_false__0\\+yVz {
  color:  red;
   font-size: 1.5rem;
}
/* Responsive Design */
@media (max-width: 768px) {
  .ComparisonTable_container__hzUmK {
    margin: 2rem auto;
    padding: 0 0.5rem;
  }

  .ComparisonTable_comparisonTitle__Q7GEe {
    font-size: 2rem;
  }

  .ComparisonTable_comparisonSubtitle__0hxjM {
    font-size: 1rem;
    padding: 0 1rem;
  }

  .ComparisonTable_table__E3CIp {
    font-size: 0.9rem;
  }

  .ComparisonTable_table__E3CIp th,
  .ComparisonTable_table__E3CIp td {
    padding: 1.5rem 0.5rem;
  }

  .ComparisonTable_featuresHeader__wOoqm {
    width: 25%;
  }

  .ComparisonTable_planHeader__jll7H {
    font-size: 0.9rem;
  }

  .ComparisonTable_popularTag__huHTL {
    font-size: 0.7rem;
    padding: 0.2rem 0.6rem;
  }

  .ComparisonTable_sectionHeaderContent__eVo6K {
    font-size: 1rem;
    padding: 0 0.5rem;
  }
}

@media (max-width: 480px) {
  .ComparisonTable_table__E3CIp {
    font-size: 0.8rem;
  }

  .ComparisonTable_table__E3CIp th,
  .ComparisonTable_table__E3CIp td {
    padding: 0.6rem 0.3rem;
  }

  .ComparisonTable_featuresHeader__wOoqm {
    width: 20%;
  }

  .ComparisonTable_labelWithIcon__Rfde3 {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/ComparisonTable.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;IACpC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,WAAW;GACV,iBAAiB;AACpB;AACA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":["/* ComparisonTable.module.css */\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 4rem auto;\n  padding: 0 1rem;\n}\n\n.comparisonTitle {\n  text-align: center;\n  font-size: 2.5rem;\n  color: #1f2937;\n  margin-bottom: 1rem;\n  font-weight: 700;\n}\n\n.comparisonSubtitle {\n  text-align: center;\n  color: #6b7280;\n  font-size: 1.1rem;\n  margin-bottom: 3rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.table th,\n.table td {\n  padding: 1.2rem 1rem;\n  text-align: center;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #374151;\n  font-size: 1.1rem;\n  position: relative;\n}\n\n.featuresHeader {\n  background: #f8fafc !important;\n  text-align: left !important;\n  font-weight: 700 !important;\n  color: #1f2937 !important;\n  width: 30%;\n}\n\n.planHeader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.popular {\n  background: linear-gradient(135deg, #f0f9ff, #e0f2fe);\n  position: relative;\n}\n\n.popular::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--primary-gradient);\n}\n\n.popularTag {\n  background:var(--primary-gradient);\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 15px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.sectionHeader {\n  background: #f1f5f9;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.sectionHeader:hover {\n  background: #e2e8f0;\n}\n\n.sectionHeaderContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 1rem;\n  font-size: 1.1rem;\n  color: #374151;\n  padding-left: 0px;\n}\n\n.sectionHeaderContent strong {\n  background-color: var(--primary-color);\n    color: white;\n    padding: 8px 12px;\n    border-radius: 12px;\n    max-width: 75%;\n    word-wrap: break-word;\n}\n\n.icon {\n  display: flex;\n  align-items: center;\n  color: #6b7280;\n}\n\n.featureRow:hover {\n  background: #f8fafc;\n}\n\n.label {\n  text-align: left;\n  font-weight: 500;\n  color: #374151;\n  background: #f8fafc;\n}\n\n.labelWithIcon {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.infoIcon {\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 0.9rem;\n  padding: 0.2rem;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  outline: none;\n  border: none;\n}\n\n.infoIcon:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.featureValue {\n  font-weight: 500;\n  color: #374151;\n  line-height: 1.4;\n}\n.featureValue .true {\n  color:  green;\n  font-size: 1.5rem;\n}\n.featureValue .false {\n  color:  red;\n   font-size: 1.5rem;\n}\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    margin: 2rem auto;\n    padding: 0 0.5rem;\n  }\n\n  .comparisonTitle {\n    font-size: 2rem;\n  }\n\n  .comparisonSubtitle {\n    font-size: 1rem;\n    padding: 0 1rem;\n  }\n\n  .table {\n    font-size: 0.9rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 1.5rem 0.5rem;\n  }\n\n  .featuresHeader {\n    width: 25%;\n  }\n\n  .planHeader {\n    font-size: 0.9rem;\n  }\n\n  .popularTag {\n    font-size: 0.7rem;\n    padding: 0.2rem 0.6rem;\n  }\n\n  .sectionHeaderContent {\n    font-size: 1rem;\n    padding: 0 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .table {\n    font-size: 0.8rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.6rem 0.3rem;\n  }\n\n  .featuresHeader {\n    width: 20%;\n  }\n\n  .labelWithIcon {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ComparisonTable_container__hzUmK`,
	"comparisonTitle": `ComparisonTable_comparisonTitle__Q7GEe`,
	"comparisonSubtitle": `ComparisonTable_comparisonSubtitle__0hxjM`,
	"table": `ComparisonTable_table__E3CIp`,
	"featuresHeader": `ComparisonTable_featuresHeader__wOoqm`,
	"planHeader": `ComparisonTable_planHeader__jll7H`,
	"popular": `ComparisonTable_popular__+HNBa`,
	"popularTag": `ComparisonTable_popularTag__huHTL`,
	"sectionHeader": `ComparisonTable_sectionHeader__KXEH7`,
	"sectionHeaderContent": `ComparisonTable_sectionHeaderContent__eVo6K`,
	"icon": `ComparisonTable_icon__Kwe-2`,
	"featureRow": `ComparisonTable_featureRow__m0U9d`,
	"label": `ComparisonTable_label__ceOCN`,
	"labelWithIcon": `ComparisonTable_labelWithIcon__Rfde3`,
	"infoIcon": `ComparisonTable_infoIcon__HmFg7`,
	"featureValue": `ComparisonTable_featureValue__40PAp`,
	"true": `ComparisonTable_true__TaElW`,
	"false": `ComparisonTable_false__0+yVz`
};
export default ___CSS_LOADER_EXPORT___;
